import React, { useState } from "react";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppBarComponent from "../../components/Structure/LayoutComponents/Appbar/AppBarComponent";
import SidebarComponent from "../../components/Structure/LayoutComponents/SideBar/SidebarComponent";
import { usePatientModal } from "../../context/PatientModalContext/PatientModalContext";
import LayPatientModal from "../../components/Advanced/Modal/LayPatientModal/LayPatientModal";
import ObservationsModal from "../../components/Advanced/Modal/ObservationsModal/ObservationsModal";
import { ViewAsRoleProvider } from "../../context/ViewAsRoleContext/ViewAsRoleContext";

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [WidthDrawDate, setWidthDrawDate] = useState(240);

  const { open, selectedPatientId, closeModal } = usePatientModal();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleOpenNavMenu = () => {
    setMobileOpen(true);
  };

  return (
    <ViewAsRoleProvider>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBarComponent
          handleOpenNavMenu={handleOpenNavMenu}
          WidthDrawDate={WidthDrawDate}
        />
        <SidebarComponent
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          WidthDraw={(width) => setWidthDrawDate(width)}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { md: `calc(100% - ${WidthDrawDate}px)` },
            transition: "width 0.3s ease",
          }}
        >
          <Toolbar />
          <Outlet />
        </Box>

        <LayPatientModal
          open={open}
          onClose={closeModal}
          selectedPatientId={selectedPatientId}
        />

        <ObservationsModal />
      </Box>
    </ViewAsRoleProvider>
  );
};

export default Layout;
